module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms15e-detail2Desc1"
    }
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_c('h4', [_c('u', [_vm._v(_vm._s(_vm.labels['HRAP31EC32']['90']))])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detail2Desc1Table,
      "data": _vm.detail,
      "addInlineEventBool": _vm.validateStaappr,
      "editInlineEventBool": true,
      "deleteInlineEventBool": true,
      "saveInlineEvent": _vm.callSave,
      "columnEvent": _vm.columnEvent,
      "deleteInlineBtnDisp": false,
      "saveInlineBtnDisp": _vm.validateStaappr
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-color-skin pull-right",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#hrms15e-popup-course2"
    },
    on: {
      "click": function($event) {
        _vm.togglePopupDesc()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.labels['HRAP31EC32']['150']) + "\n    ")])]), _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "popupCourseGap": _vm.popupCourseGap,
      "courseGapPopupTable": _vm.courseGapPopupTable,
      "receivedHrms15eCourseGapPopup": _vm.receivedHrms15eCourseGapPopup,
      "setDetailCouresAddInlineAll": _vm.setDetailCouresAddInlineAll
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e4a1e34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms15e/detail2Desc1.vue
// module id = 3806
// module chunks = 1